/**
 * System Tools Ping Store
 *
 * @since 2018-03-12
 * @author mk.ko
 */
import { checkIpv6 } from '~/utils/ip'

export const state = () => ({
  // apiUrlPath: {
  //   'ping': '/api/sm/tools/ping',
  //   'ping6': '/api/sm/tools/ping6'
  // },
  // arrResultData: [],
  // objIdData: null,
  // isEnterkey: false,
  // loopCount: 1,

  taskId: void 0,
  taskStatus: '',
  resultContents: []
})

export const mutations = {
  setTaskStart (state, payload) {
    state.taskId = payload.id
    state.taskStatus = payload.status
  },
  setTaskProgress (state, payload) {
    state.taskStatus = payload.status
    state.resultContents = payload.attributes.contents
  },
  resetTaskResult (state) {
    state.taskId = void 0
    state.taskStatus = ''
    state.resultContents = []
  }
  // // reset response of othersCheckTools
  // resetCheckToolsResult (state) {
  //   state.chkGetResponseData.resultStatus = ''
  //   state.chkGetResponseData.contentArr = []
  // }

  // arrResultDataReset () {
  //   state.arrResultData = []
  // },
  // // 아이디 추출
  // tossId (state, payload) {
  //   if (state.loopCount > 20) {
  //     state.arrResultData = ['Looping Pending Status...']
  //     state.loopCount = 1
  //     state.isEnterkey = false
  //   } else {
  //     if (payload !== undefined && payload.result !== undefined && payload.result.attributes !== undefined && payload.result.attributes.contents !== undefined) {
  //       state.arrResultData = payload.result.attributes.contents
  //     }
  //     state.objIdData = payload
  //     state.loopCount++
  //   }
  // },
  // // 결과 반환
  // setResult (state, payload) {
  //   state.arrResultData = payload
  // },
  // // 엔터키 상태변환
  // changeKeyStatus (state, payload) {
  //   state.isEnterkey = payload
  //   if (!payload) {
  //     state.loopCount = 1
  //     state.isEnterkey = false
  //   }
  // }
}

export const actions = {
  // async setSystemCheckTools ({commit, state}, checkTargetInfo) {
  //   const res = {code: 'nok'}
  //   const apiUrl = `${state.apiUrlPath['tools']}/${checkTargetInfo.toolName}`
  //   const data = await this.$axios.$post(apiUrl, {'target': checkTargetInfo.targetInfo}, state.axiosNoShowLoadingOpt)
  //   if (data.code !== undefined && ((data.code).toLowerCase() === 'ok' || (data.code).toLowerCase() === 'async')) {
  //     commit('setCheckToolsResponse', data)
  //     res.code = 'ok'
  //   } else {
  //     res.code = data.code
  //     res.reason = `code:${data.code}`
  //   }
  //   return res
  // },
  // async getResultSystemCheckTool ({commit, state}, checkTargetInfo) {
  //   // set form-api by checkTarget.
  //   const res = {code: 'nok'}
  //   try {
  //     const apiUrl = `${state.apiUrlPath['tools']}/${checkTargetInfo.toolName}/${checkTargetInfo.taskId}`
  //     const {code, result} = await this.$axios.$get(apiUrl, state.axiosNoShowLoadingOpt)
  //     if (code !== undefined && (code).toLowerCase() === 'ok') {
  //       commit('setCheckToolsResult', result)
  //       res.code = 'ok'
  //     } else {
  //       res.code = code
  //       res.reason = code
  //     }
  //     return res
  //   } catch (e) {
  //     const rslt = {status: 'FAILURE'}
  //     commit('setCheckToolsResult', rslt)
  //     res.code = 'nok'
  //     return res
  //   }
  // },

  async execCommandStart ({ commit }, { ipSegment }) {
    try {
      const isIpv6 = checkIpv6(ipSegment)
      const apiUri = isIpv6 ? '/api/sm/tools/ping6' : '/api/sm/tools/ping'

      const res = await this.$axios.$post(apiUri, {
        target: ipSegment
      }, {
        loading: false,
        successAlert: false
      })

      if (res.code === 'async' && res.result.id !== '') {
        await commit('setTaskStart', res.result)
      }
      return res
    } catch (e) {
      return {
        code: 'nok',
        errors: e
      }
    }
  },
  async execCommandProgress ({ commit, state }, { ipSegment }) {
    try {
      const isIpv6 = checkIpv6(ipSegment)
      const apiUri = isIpv6 ? `/api/sm/tools/ping6/${state.taskId}` : `/api/sm/tools/ping/${state.taskId}`

      const res = await this.$axios.$get(apiUri, {
        loading: false,
        successAlert: false
      })

      if (res.code === 'ok') {
        await commit('setTaskProgress', res.result)
      }
      return res
    } catch (e) {
      return {
        code: 'nok',
        errors: e
      }
    }
  }
}

export const getters = {}

export const strict = false
